import React, { useEffect, useRef } from "react";
import Slider from "react-slick";

const ProjectDetailsModal = ({ darkTheme, projectDetails }) => {
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0);
    }
  }, [projectDetails]);

  const itemStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  };

  const videoStyle = {
    maxWidth: "100%",
    height: "auto",
  };

  return (
    <div
      className="modal fade bg-dark-1"
      id="exampleModal"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl">
        <div
          className={
            "modal-content " + (darkTheme ? "bg-dark-2 text-light" : "")
          }
        >
          <div className="modal-body">
            <button
              type="button"
              className={"btn-close " + (darkTheme ? "btn-close-white" : "")}
              data-bs-dismiss="modal"
              aria-label="Close"
            />
            <div
              className={
                "container ajax-container " +
                (darkTheme ? "bg-dark-2 text-light" : "")
              }
            >
              <h2
                className={
                  "text-6 font-weight-600 text-center mb-4" +
                  (darkTheme ? " text-white" : "")
                }
              >
                {projectDetails?.title}
              </h2>
              <div className="row g-4">
                <div className="col-md-7">
                  <Slider {...settings} ref={sliderRef}>
                    <div className="item" style={itemStyle}>
                      {projectDetails?.thumbImage.endsWith(".mp4") ? (
                        <video
                          style={videoStyle}
                          alt=""
                          src={projectDetails?.thumbImage}
                          controls
                        />
                      ) : (
                        <img
                          className="img-fluid"
                          alt=""
                          src={projectDetails?.thumbImage}
                        />
                      )}
                    </div>
                    {projectDetails?.sliderImages?.length > 0 &&
                      projectDetails.sliderImages.map((file, index) => (
                        <div className="item" style={itemStyle} key={index}>
                          {file.endsWith(".mp4") ? (
                            <video
                              style={videoStyle}
                              alt=""
                              src={file}
                              controls
                            />
                          ) : (
                            <img className="img-fluid" alt="" src={file} />
                          )}
                        </div>
                      ))}
                  </Slider>
                </div>
                <div className="col-md-5">
                  {projectDetails && projectDetails?.objective ? (
                    <>
                      <h4
                        className={
                          "text-4 font-weight-600" +
                          (darkTheme ? " text-white" : "")
                        }
                      >
                        Objective:
                      </h4>
                      <p>{projectDetails?.objective}</p>
                    </>
                  ) : null}
                  <h4
                    className={
                      "text-4 font-weight-600" +
                      (darkTheme ? " text-white" : "")
                    }
                  >
                    Project Info:
                  </h4>
                  <p>{projectDetails?.projectInfo}</p>

                  {projectDetails?.results &&
                    projectDetails.results.length > 0 && (
                      <>
                        <h4
                          className={
                            "text-4 font-weight-600" +
                            (darkTheme ? " text-white" : "")
                          }
                        >
                          Results:
                        </h4>
                        <ul>
                          {projectDetails.results.map((result, index) => (
                            <li key={index}>{result}</li>
                          ))}
                        </ul>
                      </>
                    )}

                  <h4
                    className={
                      "text-4 font-weight-600" +
                      (darkTheme ? " text-white" : "")
                    }
                  >
                    Conclusion:
                  </h4>
                  <p>{projectDetails?.conclusion}</p>

                  <h4
                    className={
                      "text-4 font-weight-600 mt-4" +
                      (darkTheme ? " text-white" : "")
                    }
                  >
                    Project Details:
                  </h4>
                  <ul
                    className={
                      "list-style-2 " + (darkTheme ? "list-style-light" : "")
                    }
                  >
                    <li>
                      <span
                        className={
                          "text-dark font-weight-600 me-2" +
                          (darkTheme ? " text-white" : "")
                        }
                      >
                        Industry:
                      </span>
                      {projectDetails?.industry}
                    </li>
                    <li>
                      <span
                        className={
                          "text-dark font-weight-600 me-2" +
                          (darkTheme ? " text-white" : "")
                        }
                      >
                        Date:
                      </span>
                      {projectDetails?.date}
                    </li>
                    {projectDetails?.url?.name ? (
                      <li>
                        <span
                          className={
                            "text-dark font-weight-600 me-2" +
                            (darkTheme ? " text-white" : "")
                          }
                        >
                          URL:
                        </span>
                        <a
                          href={projectDetails.url.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {projectDetails.url.name}
                        </a>
                      </li>
                    ) : null}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailsModal;
